import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { User } from '../../Utilis/Types/User';

const initialState: {
  user: Partial<User> | null;
  client: Partial<User> | null;
  token: string | null;
} = {
  user: null,
  client: null,
  token: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<string | null>) {
      state.token = action.payload;
    },
    setAuthUser(state, action: PayloadAction<Partial<User>>) {
      if (action.payload) {
        state.user = {
          ...state.user,
          ...action.payload,
        };
      }
    },
    setClient(state, action: PayloadAction<Partial<User>>) {
      state.client = { ...action.payload }
    },
    removeClient(state) {
      state.client = null;
    },
    onUserLogout(state) {
      state.user = null;
      state.token = null;
    },
  },
});

export const { setToken, setAuthUser, setClient, removeClient, onUserLogout } = userSlice.actions;

export default userSlice.reducer;
